import { render, staticRenderFns } from "./MealContainer.vue?vue&type=template&id=153f5474&"
import script from "./MealContainer.vue?vue&type=script&lang=js&"
export * from "./MealContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports